/* eslint-disable */
import { SVGProps } from "react";
const SvgNoneSelected = (props:SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={74.174}
    height={64.941}
    {...props}
  >
    <g data-name="folder (1)" transform="translate(.001 -31.865)">
      <path
        data-name="Path 915"
        d="M74.173 54.859v41.946h-56.4a1.709 1.709 0 0 1-1.709-1.709V49.081a1.708 1.708 0 0 1 1.709-1.709h20.72a1.707 1.707 0 0 1 1.207.5l4.779 4.779a1.708 1.708 0 0 0 1.209.5h26.776a1.71 1.71 0 0 1 1.709 1.708Z"
        fill="#756f6f"
      />
      <g
        data-name="Group 1001"
        transform="translate(16.061 47.372)"
        fill="#5b5555"
      >
        <circle
          data-name="Ellipse 178"
          cx={4.166}
          cy={4.166}
          r={4.166}
          transform="translate(26.72 5.779)"
        />
        <path
          data-name="Path 916"
          d="M15.594 19.778a1.193 1.193 0 0 1-.843 2.037H1.597c-.539 0-1.072-.027-1.6-.078V1.709A1.708 1.708 0 0 1 1.706 0h14.851a16.055 16.055 0 0 1-3.624 17.118Z"
        />
        <path
          data-name="Path 917"
          d="M58.112 7.488v41.946h-5.674V7.488a1.709 1.709 0 0 0-1.709-1.709h5.674a1.71 1.71 0 0 1 1.709 1.709Z"
        />
      </g>
      <path
        data-name="Path 918"
        d="m56.745 75.378 17.428 21.429h-57.3a1.709 1.709 0 0 1-1.326-.631L.386 77.534a1.709 1.709 0 0 1 1.326-2.787h53.707a1.708 1.708 0 0 1 1.326.631Z"
        fill="#0070f4"
      />
      <path
        data-name="Path 919"
        d="M74.173 96.806h-7.349L49.397 75.377a1.713 1.713 0 0 0-1.325-.631h7.347a1.708 1.708 0 0 1 1.325.631Z"
        fill="#0f65db"
      />
      <path
        data-name="Path 920"
        d="M61.197 91.78H46.121a1.493 1.493 0 0 1-1.188-.589l-3.864-5.077a.746.746 0 0 1 .594-1.2h15.076a1.493 1.493 0 0 1 1.188.589l3.864 5.077a.746.746 0 0 1-.594 1.2Z"
        fill="#f8f3f1"
      />
      <path
        data-name="Path 921"
        d="M61.197 91.78h-4.85a.746.746 0 0 0 .594-1.2l-3.864-5.076a1.49 1.49 0 0 0-1.187-.589h4.849a1.49 1.49 0 0 1 1.188.589l3.864 5.076a.746.746 0 0 1-.594 1.2Z"
        fill="#efe2dd"
      />
      <path
        data-name="Path 922"
        d="M37.087 92.898h-6.848a1.12 1.12 0 1 1 0-2.239h6.848a1.12 1.12 0 1 1 0 2.239Z"
        fill="#f8f3f1"
      />
      <path
        data-name="Path 923"
        d="M34.587 89.187H31.68a1.12 1.12 0 1 1 0-2.239h2.907a1.12 1.12 0 1 1 0 2.239Z"
        fill="#f8f3f1"
      />
      <path
        data-name="Path 924"
        d="M33.694 47.898a16.036 16.036 0 1 0-16.036 16.04h13.154a1.194 1.194 0 0 0 .844-2.038l-2.659-2.659a15.985 15.985 0 0 0 4.697-11.343Z"
        fill="#0070f4"
      />
      <path
        data-name="Path 925"
        d="M31.655 61.9a1.193 1.193 0 0 1-.843 2.037h-5.409a1.193 1.193 0 0 0 .843-2.037l-1.649-1.65a1.492 1.492 0 0 1-.083-2.018 16.038 16.038 0 0 0-9.56-26.139A16.037 16.037 0 0 1 28.996 59.24Z"
        fill="#0165db"
      />
      <path
        data-name="Path 926"
        d="m20.824 47.907 2.983-2.983a2.239 2.239 0 0 0-3.166-3.166l-2.983 2.979-2.983-2.983a2.239 2.239 0 0 0-3.166 3.166l2.984 2.987-2.983 2.983a2.239 2.239 0 0 0 3.166 3.166l2.983-2.983 2.983 2.983a2.239 2.239 0 1 0 3.166-3.166Z"
        fill="#f8f3f1"
      />
      <circle
        data-name="Ellipse 179"
        cx={4.166}
        cy={4.166}
        r={4.166}
        transform="translate(42.781 49.625)"
        fill="#f4c751"
      />
      <path
        data-name="Path 927"
        d="M51.112 53.79a4.164 4.164 0 0 1-6.278 3.59 3.686 3.686 0 0 0 0-7.181 4.165 4.165 0 0 1 6.277 3.59Z"
        fill="#e8ad10"
      />
      <circle
        data-name="Ellipse 180"
        cx={3.287}
        cy={3.287}
        r={3.287}
        transform="translate(58.249 42.221)"
        fill="#f4c751"
      />
      <path
        data-name="Path 928"
        d="M64.824 45.508a3.286 3.286 0 0 1-4.955 2.833 2.909 2.909 0 0 0 0-5.667 3.287 3.287 0 0 1 4.953 2.833Z"
        fill="#e8ad10"
      />
      <g data-name="Group 1002" fill="#f88123">
        <path
          data-name="Path 929"
          d="m54.025 39.499.606-.606a1.12 1.12 0 1 0-1.583-1.583l-.606.606-.606-.606a1.12 1.12 0 1 0-1.583 1.583l.606.606-.606.606a1.12 1.12 0 1 0 1.583 1.583l.606-.606.606.606a1.12 1.12 0 0 0 1.583-1.583Z"
        />
        <path
          data-name="Path 930"
          d="M8.381 64.91a1.119 1.119 0 0 0-1.583 0l-1.054 1.054L4.69 64.91a1.12 1.12 0 0 0-1.583 1.583l1.054 1.054-1.059 1.055a1.12 1.12 0 1 0 1.583 1.583l1.054-1.054 1.063 1.049a1.12 1.12 0 0 0 1.583-1.583l-1.054-1.054 1.054-1.054a1.119 1.119 0 0 0-.004-1.579Z"
        />
      </g>
    </g>
  </svg>
);

export default SvgNoneSelected;

